// Import logos for various deployment to be selected later
import LogoNacelle from "./assets/images/logo-nacelle.png";
import LogoSandbox from "./assets/images/logo-sandbox2.png";
import LogoSandboxSelects from "./assets/images/logo-sandbox-selects.png";
import LogoShababco from "./assets/images/logo-shababco.png";
import LogoFashion from "./assets/images/logo-fashion.png";
import LogoVangogh from "./assets/images/logo-vangogh.png";
import LogoTedx from "./assets/images/logo-tedx.png";
import LogoShorelines from "./assets/images/logo-shorelines.png";

// pick up env, default to "nacelle"
// The ENV value is passed from the build/start commands in package.json to
// determine which deployment
const ENV = process.env.REACT_APP_DEPLOY_ENV || "nacelle";
/** Current deploy env (for env-specific UI like navbar logo sizing). */
export const deployEnv = ENV;

// map baseUrl based on deployment
const baseUrl_map = {
  nacelle: "https://booking.nacellegrooves.com/api/v1", // example ID for nacelle
  live: "https://booking.nacellegrooves.com/api/v1", // nacelle.live (Facebook review) — same backend as nacelle
  nacellegrooves: "https://booking.nacellegrooves.com/api/v1", // nacellegrooves.com — same backend as nacelle
  sandbox: "https://booking.sandboxfestival.com/api/v1", // sandbox festival prod
  shababco: "https://booking.sandboxfestival.com/api/v1", // sandbox festival prod
  fashion: "https://booking.nacellegrooves.com/api/v1", // sandbox festival prod
  staging: "https://stagingevents.nacellegrooves.com/api/v1", // staging environment
  shorelines: "https://booking.shorelinesfestival.com/api/v1",
  local: "http://localhost/api/v1",
  vangogh: "https://booking.beyondvangoghegypt.com/api/v1",
  tedx: "https://bookings.kamelizer.com/api/v1",
};
const baseUrl = process.env.REACT_APP_API_BASE_URL || baseUrl_map[ENV];

// map homepage link based on deployment
const homepage_link_map = {
  local: "http://localhost:3000",
  nacelle: "https://booking.nacellegrooves.com",
  live: "https://nacelle.live",
  nacellegrooves: "https://nacellegrooves.com",
  sandbox: "https://booking.sandboxfestival.com",
  shababco: "http://localhost:3000",
  fashion: "http://localhost:3000",
  staging: "https://stagingevents.nacellegrooves.com",
  shorelines: "https://booking.shorelinesfestival.com",
  vangogh: "https://booking.beyondvangoghegypt.com",
  tedx: "https://bookings.kamelizer.com",
};
export const homepage_link = homepage_link_map[ENV];

// hardcoded_event varies by deployment
const hardcoded_event_map = {
  nacelle: null, // example ID for nacelle
  live: null, // nacelle.live — same as nacelle
  nacellegrooves: null, // nacellegrooves.com — same as nacelle
  sandbox: 75, // sandbox festival prod
  shababco: 68, // sandbox festival prod
  fashion: 63, // sandbox festival prod
  staging: null, // staging environment
  shorelines: 72, // shorelines prod
  vangogh: 70, // vangogh prod
  tedx: 71, // tedx prod
};
export const hardcoded_event = hardcoded_event_map[ENV] || null;

// Select Brand Logo by Deployment
const logos = {
  nacelle: LogoNacelle,
  live: LogoNacelle,
  nacellegrooves: LogoNacelle,
  sandbox: LogoSandboxSelects,
  shababco: LogoShababco,
  fashion: LogoFashion,
  staging: LogoSandbox,
  shorelines: LogoShorelines,
  vangogh: LogoVangogh,
  tedx: LogoTedx,
};

export const logo = logos[ENV];

const rights_map = {
  nacelle: "Nacelle",
  live: "Nacelle",
  nacellegrooves: "Nacelle",
  sandbox: "Sandbox Selects",
  shababco: "Shababco",
  fashion: "Fashion Forward",
  staging: "Sandbox Festival",
  shorelines: "Shorelines Festival",
  vangogh: "Beyond Van Gogh Egypt",
  tedx: "TEDx East Katameya",
};

export const rights = `${rights_map[ENV]}. All rights reserved`;

// Company legal info shown in the footer (per-env; live / nacellegrooves)
const company_info_map = {
  live: "Nacelle Live FZCO — Sheikh Rashid Tower, Floor 18, Dubai World Trade Centre, Dubai, Dubai, United Arab Emirates",
  nacellegrooves:
    "Nacelle Live FZCO — Sheikh Rashid Tower, Floor 18, Dubai World Trade Centre, Dubai, Dubai, United Arab Emirates",
};

export const company_info = company_info_map[ENV] || null;

// "Looking for a table?" contact shown in the footer (per-env)
const table_contact_map = {
  sandbox: { email: "info@sandboxfestival.com", phone: "+201020701701" },
  staging: { email: "info@sandboxfestival.com", phone: "+201020701701" },
};

export const table_contact = table_contact_map[ENV] || null;

// Deployments with a hardcoded event land on that event's booking page instead of /booking.
const landing_path = hardcoded_event ? `/booking/${hardcoded_event}` : "/booking";
export const isLandingPath = (pathname) => pathname.replace(/\/+$/, "") === landing_path;

const pixel_id_map = {
  nacelle: "1220477249278262",
  live: "1220477249278262",
  nacellegrooves: "1220477249278262",
  sandbox: "1515552869011765",
  shababco: "1220477249278262",
  staging: "1220477249278262",
  shorelines: "3599703440205971",
  vangogh: "1220477249278262",
  tedx: "2172618710233066",
};

export const pixel_id = pixel_id_map[ENV];

// Routes

const authUrl = `${baseUrl}/auth`;
const customersUrl = `${baseUrl}/customers`;
const eventsUrl = `${baseUrl}/events`;
const cartUrl = `${baseUrl}/carts`;
const paymentUrl = `${baseUrl}/ticket_order_payments`;
const orderUrl = `${baseUrl}/ticket_orders`;
const upgradeUrl = `${baseUrl}/ticket_upgrade_orders`;
const cashTransactionsUrl = `${baseUrl}/cashless/cash-transactions`;

export const routes = {
  base: baseUrl,

  login: `${authUrl}/login-v2/`,
  register: `${authUrl}/signup/`,
  logout: `${authUrl}/logout/`,
  forgotPassword: `${customersUrl}/forgot-password/`,
  resetPassword: `${customersUrl}/reset-password/`,
  me: `${authUrl}/me/`,
  pippUserData: `${baseUrl}/pipp/user-data/`,
  changePassword: `${authUrl}/change-password/`,
  changeInfo: `${customersUrl}/update-profile/`,
  verifyOtp: `${authUrl}/verify-email-otp/`,
  resendOtp: `${authUrl}/resend-email-otp/`,
  customerDetails: `${customersUrl}/details/`,

  eventsList: `${eventsUrl}/`,
  getEventById: (id) => `${eventsUrl}/${id}/`,
  ticketTiers: (id) => `${eventsUrl}/${id}/ticket-tiers/`,
  ticketTierSlots: (eventPk, tierPk) =>
    `${eventsUrl}/${eventPk}/ticket-tiers/${tierPk}/slots/`,
  ticketTierSlotsAvailability: (eventPk, tierPk) =>
    `${eventsUrl}/${eventPk}/ticket-tiers/${tierPk}/slots/availability/`,
  addons: (id) => `${eventsUrl}/${id}/add-ons/`,
  preregister: `${baseUrl}/pre-register/`,

  addTicketsToCart: `${cartUrl}/anonymous/`,
  cancelCart: `${cartUrl}/cancel/`,

  validateVoucher: `${baseUrl}/vouchers/validate/`,

  getOrderItems: (id) => `${orderUrl}/${id}`,
  ordersList: `${orderUrl}/`,

  cashTransactionsList: `${cashTransactionsUrl}/`,
  cashTransactionsDebits: `${cashTransactionsUrl}/debits/`,
  cashTransactionsCredits: `${cashTransactionsUrl}/credits/`,

  payCart: `${paymentUrl}/`,
  submitReservation: `${baseUrl}/prepaid_reservation_orders/order/`,
  checkPayment: `${baseUrl}/prepaid_reservation_orders/check-payment/`,
  getReservations: `${baseUrl}/prepaid_reservation_orders`,
  getReservationsById: (id) => `${baseUrl}/prepaid_reservation_orders/${id}/`,
  getFriendOrder: (id, token) =>
    `${baseUrl}/prepaid_reservation_orders/${id}/anonymous_order/?token=${token}`,
  payReservationAnonymously: (reservation, order_id) =>
    `${baseUrl}/reservations/${reservation}/orders/${order_id}/payments/anonymous/`,

  getTicketUpgradeOrder: (token) => `${upgradeUrl}/${token}/`,

  getInvitationOrder: (token) => `${baseUrl}/invitations/${token}/`,
  sendInvitationOrder: (id, portal) =>
    `${baseUrl}/invitations/${id}/${portal}/`,
  getInvitationReceipt: (id) => `${baseUrl}/prepaid_reservation_orders/${id}/`,
  payReservation: (reservation, order) =>
    `${baseUrl}/reservations/${reservation}/orders/${order}/payments/`,

  getMyTables: `${baseUrl}/tables/`,
  getTable: (code) => `${baseUrl}/tables/${code}/`,
  getTableByToken: (token) => `${baseUrl}/tables/manage/${token}/`,
  // Serves both PATCH (assign) and DELETE (clear) -- they share the URL.
  tableSeat: (code, position) => `${baseUrl}/tables/${code}/seats/${position}/`,
  resendTableSeatPass: (code, position) =>
    `${baseUrl}/tables/${code}/seats/${position}/resend/`,
  tableSeatChangeRequest: (code, position) =>
    `${baseUrl}/tables/${code}/seats/${position}/change-request/`,

  tableRequests: `${baseUrl}/table-requests/`,
  tableRequest: (id) => `${baseUrl}/table-requests/${id}/`,
  payTableRequest: (id) => `${baseUrl}/table-requests/${id}/pay/`,

  faqsList: `${baseUrl}/faqs/`,

  fetchUser: (email) => `${customersUrl}/email/?email=${email}`,

  anonymousRegister: `${customersUrl}/anonymous/`,
  createUser: `${customersUrl}/`,
};

export const AXIOS_DEFAULT_CONFIG = {
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
  contentType: "application/json",
};

export const VAT = 0.14;
export const entertainmentTax = 0.1;

export const lockUserTicket = false;
export const ticketLimit = 4;
export const warnAt = 3;

//export const redirect_to = "http://localhost";
//export const redirect_to = "https://booking.nacellegrooves.com";
//export const redirect_to = "https://booking.sandboxfestival.com";
//export const redirect_to = "https://stagingevents.nacellegrooves.com";

export const seatsio_public_key = "20c7144b-0b02-4c37-be47-421be7be0778";

export const min_payment = 10;

//Stripe test key pk_test_51N08jtLL3r41ZoBN6bI2MoP621LR1MWp1yzzJfisrIHytwFCJmFnib1bvJYlhxe0NEEQIh88hUMyxC8QIKvacaOi00C4Z9uClF
//Stripe prod key pk_live_51N08jtLL3r41ZoBNolS6BgOx48oYzh9cNzhLKb2A84yRcl0kEagStXtQx7LFXU2E0usE0gsaAodYvbVUuXPpHWXl00GyrJXzdu
// export const stripe_publishable_id =
//   "pk_test_51N08jtLL3r41ZoBN6bI2MoP621LR1MWp1yzzJfisrIHytwFCJmFnib1bvJYlhxe0NEEQIh88hUMyxC8QIKvacaOi00C4Z9uClF";
export const stripe_publishable_id =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  "pk_live_51N08jtLL3r41ZoBNolS6BgOx48oYzh9cNzhLKb2A84yRcl0kEagStXtQx7LFXU2E0usE0gsaAodYvbVUuXPpHWXl00GyrJXzdu";

export const currency = "EGP";

export const external_platform = {
  id: 55,
  redirect_url: "https://link.tickit.co/937w",
};

export const MASS_TICKETING_RESERVATION_FLOW = "mass_ticketing";

export const isMassTicketingReservationFlow = (event) =>
  event?.reservationFlow === MASS_TICKETING_RESERVATION_FLOW;
